import useAccessToken from 'hooks/useAccessToken';
import useFetch from 'hooks/useFetch';

import useTranslation from 'pages/VerifyEmailPage/hooks/useTranslation';

import { SEND_EMAIL_API } from './constants';

const useSendEmail = () => {
    const { httpPost } = useFetch();
    const { fetchToken } = useAccessToken();
    const { API_ERROR } = useTranslation();

    const sendEmail = async () => {
        const token = await fetchToken();

        if (!token) {
            alert(API_ERROR);

            return;
        }

        const response = await httpPost(
            SEND_EMAIL_API,
            {},
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        );

        if (response.error) {
            alert(API_ERROR);

            return;
        }
    };

    return {
        sendEmail
    };
};

export default useSendEmail;
